export var now = function () {
    return Date.now ? Date.now() : +(new Date());
};



//////////////////
// WEBPACK FOOTER
// /Users/sheweichun/npmplace/tumbling/node_modules/.2.18.1@moment/src/lib/moment/now.js
// module id = 143
// module chunks = 0